import { compareAsc, compareDesc, isBefore, parseISO, subMinutes } from "date-fns";

export const isMoreThanXMinutesAgo = (dateString: string, minutes: number) => {
  const date = parseISO(dateString); // parses ISO string to Date
  const fiveMinutesAgo = subMinutes(new Date(), minutes);
  return isBefore(date, fiveMinutesAgo);
};

/** compareDesc that sorts nulls/empty strings to the end. */
export const compareDateDescNullsLast = (a: string | null, b: string | null) => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return compareDesc(a, b);
};

/** compareAsc that sorts nulls/empty strings to the end. */
export const compareDateAscNullsLast = (a: string | null, b: string | null) => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return compareAsc(a, b);
};

const timezoneNameFormatters = new Map<string, Intl.DateTimeFormat>();

const getTimezoneNameFormatter = (timeZone: string, timeZoneName: "shortOffset" | "short") => {
  const cacheKey = `${timeZone}:${timeZoneName}`;
  const cached = timezoneNameFormatters.get(cacheKey);
  if (cached) return cached;
  // Cached per timeZone + style; Intl construction is expensive.
  // react-doctor-disable-next-line react-doctor/js-hoist-intl
  const formatter = new Intl.DateTimeFormat("en-US", { timeZone, timeZoneName });
  timezoneNameFormatters.set(cacheKey, formatter);
  return formatter;
};

/** e.g. `Los Angeles (GMT-7)` from the browser IANA zone and current offset. */
export function formatLocalTimezoneLabel(date = new Date()): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const citySegment = timeZone.includes("/") ? (timeZone.split("/").pop() ?? timeZone) : timeZone;
  const city = citySegment.replace(/_/g, " ");

  let offset: string | undefined;
  try {
    offset = getTimezoneNameFormatter(timeZone, "shortOffset")
      .formatToParts(date)
      .find((p) => p.type === "timeZoneName")?.value;
  } catch {
    offset = undefined;
  }

  if (!offset) {
    offset =
      getTimezoneNameFormatter(timeZone, "short")
        .formatToParts(date)
        .find((p) => p.type === "timeZoneName")?.value ?? "";
  }

  return offset ? `${city} (${offset})` : city;
}
